// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.templateDeleteModal__tWAeM {
  width: 372px;
  height: 464px;
}

.modalBody__R2d07 {
  padding: 35px 51px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.modalBodyTitle__V_AcP {
  margin-bottom: 20px;
  text-align: center;
  color: var(--header-title-main);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-transform: uppercase;
}

.confirmText__rssQj {
  margin-top: 20px;
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-align: center;
}

.modalFooter___eqFs {
  padding: 35px 51px 35px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/TemplateDeleteModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,oBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,OAAA;AAzEF;;AA4EA;EACE,mBAAA;EACA,kBAAA;EAvBA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AAjDF;;AAuEA;EACE,gBAAA;EACA,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AApEF;;AAuEA;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AApEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.templateDeleteModal {\n  width: 372px;\n  height: 464px;\n}\n\n.modalBody {\n  padding: 35px 51px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  flex: 1;\n}\n\n.modalBodyTitle {\n  margin-bottom: 20px;\n  text-align: center;\n  @include modalTitle;\n}\n\n.confirmText {\n  margin-top: 20px;\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-align: center;\n}\n\n.modalFooter {\n  padding: 35px 51px 35px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"templateDeleteModal": `templateDeleteModal__tWAeM`,
	"modalBody": `modalBody__R2d07`,
	"modalBodyTitle": `modalBodyTitle__V_AcP`,
	"confirmText": `confirmText__rssQj`,
	"modalFooter": `modalFooter___eqFs`
};
module.exports = ___CSS_LOADER_EXPORT___;
